var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TerminalPreview',{staticClass:"challenge-terminal",scopedSlots:_vm._u([{key:"terminal-content",fn:function(){return [_c('v-shell',{staticClass:"shell",attrs:{"banner":_vm.banner,"shell_input":_vm.send_to_terminal,"commands":_vm.commands},on:{"shell_output":_vm.prompt}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }